export const SESSION_DATA = {
  'Digital session': { bgColor: '', description: 'Digital session is an analysis session where a user uploads up to 4 videos of themselves or team and the coach responds with a coaching video analyzing this footage and providing insights, tips and feedback. The footage is the users to keep and review whenever they need it.' },
  'LIVE session': { bgColor: '', description: 'The LIVE analysis session allows a user to receive real time feedback from an expert. The expert will talk to the user in real time providing them with feedback and analysis to help them improve. Just like face to face coaching, only digitally.' },
  'LIVE class': { bgColor: '', description: 'A LIVE class is just like a LIVE session where there can be multiple users as well as observers. This allows users to receive real time feedback from an expert. The expert will talk to the users in real time providing them with feedback and analysis to help them improve.' },
  Course: { bgColor: '', description: 'Courses are a collection of sessions/content/forms etc. with set levels which a user can complete at their own pace and earn badges and accreditation upon completion.' },
  'Content only': { bgColor: '', description: 'Content only session type will allow a user to access a collection of free or premium content, which once purchased they will be able to access anytime and make use of it' },
};

export enum CURRENCIES {
  'USD' = '$',
  'GBP' = '£',
  'AUD' = 'A$',
}

export enum CategoryResourceType {
  SESSION = 0,
  EXPERT = 1,
  ARTICLE = 2,
}
